import React from "react"

import { withImages } from "./withImages"
import { Section, Image } from "./ImagesStyles"

export const Images = withImages(
  ({ images }): JSX.Element => (
    <Section length={images?.length}>
      {images?.map((image: any, index: number) => (
        <Image key={image?.id} alt={image?.alt} fluid={image} index={index} length={images?.length} />
      ))}
    </Section>
  )
)

export default Images
